import React, { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Box } from '@atoms'
import { Button } from '@interco/inter-ui/components/Button'
import { Text } from '@interco/inter-ui/components/Text'
import Tag from '@utils/Tag'
import { ApplicationState } from '@store/types'
import routes from '@routes/routes'
import { Page } from '@templates'
import { StepRefin } from '@utils/enums'
import { trackingRefin } from '@store/refinanciamento/simulacao/actions'
import { postDadosPessoaisRequest } from '@store/refinanciamento/dadosPessoais/actions'

import { ColumnLeft } from './styles'

const InformacoesPessoais = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { logradouro, bairro, numero, complemento, uf, cidade, cep } = useSelector(
    (state: ApplicationState) => state.refinanciamento.endereco,
  )

  const { agencia, contaDadosBancarios, digito, bancoNome, isBankAccountEditable } = useSelector(
    (state: ApplicationState) => state.refinanciamento.dadosBancarios,
  )
  const { correctionMode, postDadosPessoaisLoading } = useSelector(
    (state: ApplicationState) => state.refinanciamento.dadosPessoais,
  )
  useEffect(() => {
    if (correctionMode) {
      navigate(routes.DADOS_BANCARIOS, { replace: true })
    }
  }, [correctionMode, navigate])

  useEffect(() => {
    Tag.enviarTagueamentoWeb({
      element_action: 'data_loaded',
      element_name: '',
      c_page: window.location.href,
      redirect_url: '',
      section_name: 'payrollloan:refin:data',
      section: 'data',
      sub_section: '',
      step: '',
      scenario: 'filled',
    })
  }, [])

  return (
    <Page
      positionFooter="sticky"
      stickyContainerFooterBottom="10px"
      stickyFooter={
        <Button
          variant="primary"
          fullWidth
          disabled={postDadosPessoaisLoading}
          isLoading={postDadosPessoaisLoading}
          onClick={() => {
            if (postDadosPessoaisLoading) {
              return
            }

            dispatch(trackingRefin(StepRefin.CLICK_INFORMACOES_PESSOAIS_CONFIRMAR))
            Tag.enviarTagueamentoWeb({
              element_name: 'confirmar',
              section_name: 'payrollloan:refin:data',
              section: 'data',
              element_action: 'click button',
              c_page: window.location.href,
              redirect_url: `${window.location.origin}${routes.CARREGAMENTO_SIMULACAO}`,
              step: '',
              scenario: 'filled',
            })
            dispatch(trackingRefin(StepRefin.DADOS_RECEBIDO))

            if (correctionMode) {
              navigate(routes.DADOS_BANCARIOS, { replace: true })
              return
            }

            dispatch(
              postDadosPessoaisRequest({
                callback: () => navigate(routes.CARREGAMENTO_SIMULACAO),
                invalidModalityAccountCallback: () =>
                  navigate(routes.DADOS_BANCARIOS, { replace: true }),
              }),
            )
          }}
        >
          Confirmar informações
        </Button>
      }
    >
      <Text variant="headline-h1" semiBold colorWeight={500}>
        Confirme suas informações
      </Text>

      <Box justify="space-between" margin="16px 0 0 0" direction="row" align="center">
        <ColumnLeft>
          <Text variant="body-3" bold colorWeight={500} style={{ marginBottom: '8px' }}>
            Endereço
          </Text>
          <Text variant="caption-1">
            {logradouro} {numero} {complemento}, {bairro}
          </Text>
          <Text variant="caption-1">
            {cidade}, {uf}
          </Text>
          <Text variant="caption-1">CEP {cep}</Text>
        </ColumnLeft>
        <Text
          style={{ cursor: 'pointer' }}
          color="primary"
          variant="body-3"
          bold
          colorWeight={500}
          onClick={() => {
            dispatch(trackingRefin(StepRefin.CLICK_INFORMACOES_PESSOAIS_ALTERAR_ENDERECO))
            Tag.enviarTagueamentoWeb({
              element_action: 'click button',
              element_name: 'alterar endereço',
              c_page: window.location.href,
              redirect_url: routes.ENDERECO,
              section_name: 'payrollloan:refin:data',
              section: 'data',
              sub_section: '',
              step: '',
              scenario: 'alterar endereço',
            })
            navigate(routes.ENDERECO, {
              state: { fromInformacoesPessoais: true },
            })
          }}
        >
          Alterar
        </Text>
      </Box>

      <Box justify="space-between" margin="16px 0 0 0" direction="row" align="center">
        <ColumnLeft>
          <Text variant="body-3" bold colorWeight={500} style={{ marginBottom: '8px' }}>
            Dados bancários
          </Text>
          <Text variant="caption-1">{bancoNome}</Text>
          <Text variant="caption-1">Agência {agencia}</Text>
          <Text variant="caption-1">
            Conta {contaDadosBancarios}-{digito}
          </Text>
        </ColumnLeft>
        <Text
          style={{
            cursor: isBankAccountEditable ? 'pointer' : 'not-allowed',
            opacity: isBankAccountEditable ? 1 : 0.5,
          }}
          color="primary"
          variant="body-3"
          bold
          colorWeight={500}
          onClick={() => {
            dispatch(trackingRefin(StepRefin.CLICK_INFORMACOES_PESSOAIS_ALTERAR_BANCARIOS))
            if (isBankAccountEditable) {
              Tag.enviarTagueamentoWeb({
                element_action: 'click button',
                element_name: 'alterar bancários',
                c_page: window.location.href,
                redirect_url: routes.DADOS_BANCARIOS,
                section_name: 'payrollloan:refin:data',
                section: 'data',
                sub_section: '',
                step: '',
                scenario: 'alterar bancários',
              })
              navigate(routes.DADOS_BANCARIOS, {
                state: { fromInformacoesPessoais: true },
              })
            }
          }}
          aria-disabled={!isBankAccountEditable}
        >
          Alterar
        </Text>
      </Box>
    </Page>
  )
}

export default InformacoesPessoais
